const TYPING_INPUT_TYPES = new Set([
  "text",
  "search",
  "email",
  "password",
  "url",
  "tel",
  "number",
  "date",
  "datetime-local",
  "month",
  "time",
  "week",
]);

export const isVideoEditorTypingTarget = (target) => {
  if (!target?.closest) {
    return false;
  }

  if (target.closest("textarea, [contenteditable='true'], [role='textbox']")) {
    return true;
  }

  const input = target.closest("input");
  if (!input) {
    return false;
  }

  const type = String(input.type || "text").toLowerCase();
  return TYPING_INPUT_TYPES.has(type);
};

export const isVideoEditorSpaceToggleEvent = (event) => {
  if (!event || event.repeat) {
    return false;
  }
  if (event.ctrlKey || event.metaKey || event.altKey) {
    return false;
  }

  return event.code === "Space" || event.key === " ";
};
